/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function LastName({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Person/LastName",
  isInvalid,
  onChange
  
}) {
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.last_name',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.last_name',
validate: fromValidate.name,
required: true,
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.person.last_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 disabled={true}
 data="edit_professional.employee.provider.employee_resource.employment_contract.person.last_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonLastNameIsValidData}
 value={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonLastNameValueData}
 onChange={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractPersonLastNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}